import _ from "lodash"
export function checkInitParams(param) {
  let isValid = true
  if (!_.isFinite(param.app_id)) {
    isValid = false
    console.warn("初始化失败！appid 为必传参数，且类型为number类型")
  }
  if (param.auto_report && !_.isBoolean(param.auto_report)) {
    isValid = false
    console.warn("初始化失败！auto_report 的类型为boolean类型")
  }
  if (param.log && !_.isBoolean(param.log)) {
    isValid = false
    console.warn("初始化失败！log 的类型为boolean类型")
  }
  if (!_.isNil(param.enable_profile) && !_.isBoolean(param.enable_profile)) {
    isValid = false
    console.warn("初始化失败！enable_profile 的类型为boolean类型")
  }
  return isValid
}
